import React, { useEffect, cloneElement, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import TYPE from "../../../../constant/TYPE";
import { setAnsweringQuestionsAction } from "../../../../redux/answeringQuestions/answeringQuestions";
import { setQuestionViewAction } from "../../../../redux/answeringQuestions/questionView";
import { setAnswerEditorAction } from "../../../../redux/answeringQuestions/answerEditor";
import useScribbleTooltip from "../../../../hooks/answeringQuestions/useScribbleTooltip";
import useAmplitude from "../../../../hooks/useAmplitude";

const deviceType = [
  TYPE.DEVICE.PAD,
  '',
  TYPE.DEVICE.PHONE,
  TYPE.DEVICE.PC
];

const Viewer = ( props ) => {

  const deviceInfo = useSelector( state => state.deviceInfo );
  const mathjax = useSelector( state => state.mathjax );
  const answeringQuestions = useSelector( state => state.answeringQuestions );
  const questionView = useSelector( state => state.questionView );
  const answerEditor = useSelector( state => state.answerEditor );

  const dispatch = useDispatch();
  const { setAmplitudeLog } = useAmplitude();
  const setAnsweringQuestions = payload => { dispatch( setAnsweringQuestionsAction( payload ) ) };
  const setQuestionView = payload => { dispatch( setQuestionViewAction( payload ) ) };
  const setAnswerEditor = payload => { dispatch( setAnswerEditorAction( payload ) ) };

  const { showScribbleTooltip } = useScribbleTooltip();

  useEffect( () => {
    if ( deviceInfo.type && answeringQuestions.data.fontSize ) {
      const deviceScale = TYPE.DEVICE.PHONE === deviceInfo.type ? 1.5 : 2;
      const userScale = answeringQuestions.data.fontSize.split( ';' ).map( v => parseInt( v ) );
      const userScaleIndex = deviceType.map( ( v, i ) => deviceInfo.type === v ? i : NaN ).filter( v => ! isNaN( v ) )[ 0 ];
      setQuestionView( { scale : deviceScale * userScale[ userScaleIndex ] / 100 } );
    }
  }, [ deviceInfo.type, answeringQuestions.data.fontSize ] );

  useEffect( () => {
    if ( questionView.PV_CONT && questionView.scale && mathjax.renderKey.question ) {
      setTimeout( () => {
        setQuestionView( { size : [ questionView.PV_CONT.offsetWidth, questionView.PV_CONT.offsetHeight ].map( v => v * questionView.scale + 20 ) } );
      } );
    }
  }, [ questionView.PV_CONT, questionView.scale, mathjax.renderKey.question ] );

  const selectArea = ( event ) => {
    const highlightArea = event.target.closest( '.active-bd' );
    
    if ( highlightArea ) {
      const answerArea = highlightArea.querySelector( `[ id*=${ TYPE.ID.ANSWER_AREA } ]` ) || highlightArea.previousSibling.querySelector( `[ id*=${ TYPE.ID.ANSWER_AREA } ]` );
      setAnsweringQuestions( { answerIndex : parseInt( answerArea.id.slice( TYPE.ID.ANSWER_AREA.length ) ) } );
      ! answerEditor.isShow && setAnswerEditor( { answerKey : '' } );
    } else {
      const name = !answeringQuestions?.learningType ? '진단연습장 시작' : '학습연습장 시작';
      // 연습장 on??
      setAnsweringQuestions( { isShowKeypad : false } );
      setQuestionView( { tooltipStatus : 0 } );
      showScribbleTooltip();
      
      if (answeringQuestions.isShowKeypad) {
        setAmplitudeLog({
          eventName: {
            name,
            event: {
              "학습유형": '',
              "소주제이름": answeringQuestions?.data?.stepNm,
              "소주제코드": answeringQuestions?.data?.stgCd,
              "문항코드": answeringQuestions?.data?.qstCd,
              "커리큘럼그룹": answeringQuestions?.data?.thmaNm,
              "커리큘럼명": answeringQuestions?.data?.stepNm,
            }
          },
          isHackleSend: true,
        })
      }

    }
  };

  return cloneElement( props.children || <Fragment />, {
    onSelect : selectArea
  } );

};

export default Viewer;
